// extracted by extract-css-chunks-webpack-plugin
module.exports = {"content":"content___3T0Wk","testimonials":"testimonials___NWXxq","left":"left___1hydR","testimonial-content":"testimonial-content___cHc9p","section":"section___2AVI2"};